import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class RequestEventsHub {
    private static workflowInstanceRegisteredStream: Subject<Backend.RequestListItem> = new Subject();
    private static requestCancellationCompletedStream: Subject<Backend.RequestListItem> = new Subject();
    private static requestRejectedByCarrierStream: Subject<Backend.RequestListItem> = new Subject();
    private static requestPartiallyApprovedByCarrierStream: Subject<Backend.RequestListItem> = new Subject();
    private static workflowCompletedStream: Subject<Backend.RequestListItem> = new Subject();
    private static stageTakenToWorkStream: Subject<Backend.DepartmentTasksListItem> = new Subject();
    private static stageCompletedStream: Subject<Backend.DepartmentTasksListItem> = new Subject();
    private static stageRejectedStream: Subject<Backend.DepartmentTasksListItem> = new Subject();
    private static stageCancelledStream: Subject<Backend.DepartmentTasksListItem> = new Subject();

    /* eslint-disable @typescript-eslint/member-ordering */
    public static workflowInstanceRegistered$: Observable<Backend.RequestListItem> = RequestEventsHub.workflowInstanceRegisteredStream.asObservable();
    public static requestCancellationCompleted$: Observable<Backend.RequestListItem> = RequestEventsHub.requestCancellationCompletedStream.asObservable();
    public static requestRejectedByCarrier$: Observable<Backend.RequestListItem> = RequestEventsHub.requestRejectedByCarrierStream.asObservable();
    public static workflowCompleted$: Observable<Backend.RequestListItem> = RequestEventsHub.workflowCompletedStream.asObservable();
    public static requestPartiallyApprovedByCarrier$: Observable<
        Backend.RequestListItem
    > = RequestEventsHub.requestPartiallyApprovedByCarrierStream.asObservable();

    public static stageTakenToWork$: Observable<Backend.DepartmentTasksListItem> = RequestEventsHub.stageTakenToWorkStream.asObservable();
    public static stageCompleted$: Observable<Backend.DepartmentTasksListItem> = RequestEventsHub.stageCompletedStream.asObservable();
    public static stageRejected$: Observable<Backend.DepartmentTasksListItem> = RequestEventsHub.stageRejectedStream.asObservable();
    public static stageCancelled$: Observable<Backend.DepartmentTasksListItem> = RequestEventsHub.stageCancelledStream.asObservable();

    public static initialize(): void {
        if (!ETR || ETR.isAnonymous) {
            return;
        }
        const connection = new signalR.HubConnectionBuilder()
            .configureLogging(ETR.isProduction ? signalR.LogLevel.Warning : signalR.LogLevel.Information)
            .withUrl('/request-events-hub', { transport: signalR.HttpTransportType.WebSockets })
            .build();

        connection.on('WorkflowInstanceRegistered', (item: Backend.RequestListItem) => {
            RequestEventsHub.workflowInstanceRegisteredStream.next(item);
        });
        connection.on('RequestCancellationCompleted', (item: Backend.RequestListItem) => {
            RequestEventsHub.workflowInstanceRegisteredStream.next(item);
        });
        connection.on('RequestRejectedByCarrier', (item: Backend.RequestListItem) => {
            RequestEventsHub.requestRejectedByCarrierStream.next(item);
        });
        connection.on('RequestPartiallyApprovedByCarrier', (item: Backend.RequestListItem) => {
            RequestEventsHub.requestPartiallyApprovedByCarrierStream.next(item);
        });
        connection.on('WorkflowCompleted', (item: Backend.RequestListItem) => {
            RequestEventsHub.workflowCompletedStream.next(item);
        });
        connection.on('StageTakenToWork', (item: Backend.DepartmentTasksListItem) => {
            RequestEventsHub.stageTakenToWorkStream.next(item);
        });
        connection.on('StageCompleted', (item: Backend.DepartmentTasksListItem) => {
            RequestEventsHub.stageCompletedStream.next(item);
        });
        connection.on('StageRejected', (item: Backend.DepartmentTasksListItem) => {
            RequestEventsHub.stageRejectedStream.next(item);
        });
        connection.on('StageCancelled', (item: Backend.DepartmentTasksListItem) => {
            RequestEventsHub.stageCancelledStream.next(item);
        });

        connection.start();
    }
}

RequestEventsHub.initialize();
